<template>
<div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  methods:{

  },
  created() {
  }
}
</script>


<style lang="less">
@import "./assets/css/common.css";
@import "./assets/css/bigscreen.css";
/*1rem=10px*/
@import "./assets/css/comm_wap.css";

/* 标题字体 */
@font-face {
  font-family: "MGQ8102";
  src: url("./assets/fonts/MGQ8102.ttf");
}

/* 正文字体 */
@font-face {
  font-family: "MHR8102";
  src: url("./assets/fonts/MHR8102.ttf");
}

.titlefont {
  font-family: "MGQ8102" !important;
}

.contentfont {
  font-family: "MHR8102" !important;
}

@font-face {
  font-family: "OrhonChaganTig";
  src: url("./assets/fonts/OrhonChaganTig.ttf") format("truetype");
}
@font-face {
  font-family: "OrhonHawangTig";
  src: url("./assets/fonts/OrhonHawangTig.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonChaganTig-H";
  src: url("./assets/fonts/OrhonChaganTig-H.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonChaganTig-RTL";
  src: url("./assets/fonts/OrhonChaganTig-RTL.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonChaganTig-V";
  src: url("./assets/fonts/OrhonChaganTig-V.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig";
  src: url("./assets/fonts/OrhonGarchagTig.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig-H";
  src: url("./assets/fonts/OrhonGarchagTig-H.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonGarchagTig-RTL";
  src: url("./assets/fonts/OrhonGarchagTig-RTL.ttf") format("truetype");
}

@font-face {
  font-family: "OrhonGarchagTig-V";
  src: url("./assets/fonts/OrhonGarchagTig-V.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OrhonCaiyunTig";
  src: url("./assets/fonts/OrhonCaiyunTig.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

* {
  margin: 0;
  padding: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  //font-family: "MGQ8102" !important;
}
/* 元素竖排 */
.aqt_su {
  writing-mode: vertical-lr;
}

/* 元素取消竖排 */
.aqt_no_su {
  writing-mode: horizontal-tb;
}

/* 蒙语字竖起来的属性 */
.aqt_lang_mn {
  writing-mode: vertical-lr;
  text-orientation: sideways-right;
  text-orientation: sideways !important;
  -o-text-orientation: sideways !important;
  -ms-text-orientation: sideways !important;
  -moz-text-orientation: sideways !important;
  -webkit-text-orientation: sideways !important;
  -webkit-text-orientation: sideways-right !important;
}

/* 上下左右剧中 */
.aqt_ce_ve {
  display: flex;
  width: 100%;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  display: -ms-flexbox;
  justify-content: center;
}

//全局提示
.ivu-message{
  display: flex!important;
  justify-content: flex-end!important;
  .ivu-message-notice{
    width: 54px!important;
    .ivu-message-notice-content{
      padding: 16px 8px!important;
      .ivu-message-custom-content{
        writing-mode: vertical-lr!important;
        text-orientation: sideways-right;
        text-orientation: sideways !important;
        -o-text-orientation: sideways !important;
        -ms-text-orientation: sideways !important;
        -moz-text-orientation: sideways !important;
        -webkit-text-orientation: sideways !important;
        -webkit-text-orientation: sideways-right !important;
        font-family: "MGQ8102" !important;
      }
    }
  }
}
//禁止图片拖拽
img{
  -webkit-user-drag: none; /* Safari */
  -khtml-user-drag: none; /* Konqueror */
  -moz-user-drag: none; /* Firefox */
  -o-user-drag: none; /* Opera */
  user-drag: none; /* 其他浏览器 */
}




</style>
